module.exports = __webpack_public_path__ + "static/img/04050B_2_C_20200120_LC.49e357c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/04050B_2_C_20200120_LC.png
// module id = xsb9
// module chunks = 0